import type { SocialLinks } from "@workspace/api-client-react";

export function normalizeWhatsAppNumber(value: string): string {
  let digits = value.replace(/\D/g, "");
  if (!digits) return "";
  if (digits.startsWith("0092")) digits = digits.slice(2);
  if (digits.startsWith("92")) return `92${digits.slice(2).replace(/^0+/, "")}`;
  if (digits.startsWith("0")) return `92${digits.replace(/^0+/, "")}`;
  if (digits.length === 10) return `92${digits}`;
  return digits;
}

export function buildWhatsAppHref(value: string, message?: string): string | null {
  const digits = normalizeWhatsAppNumber(value);
  if (!/^92\d{10}$/.test(digits)) return null;
  return `https://wa.me/${digits}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
}

export function isValidSocialProfileUrl(value: string, platform: "facebook" | "instagram"): boolean {
  try {
    const url = new URL(value.trim());
    const domain = platform === "facebook" ? "facebook.com" : "instagram.com";
    return url.protocol === "https:"
      && !url.username
      && !url.password
      && !url.port
      && (url.hostname === domain || url.hostname.endsWith(`.${domain}`));
  } catch {
    return false;
  }
}

export function getSocialHrefs(links: SocialLinks) {
  return {
    facebook: links.facebook.enabled && isValidSocialProfileUrl(links.facebook.url, "facebook")
      ? links.facebook.url.trim()
      : null,
    instagram: links.instagram.enabled && isValidSocialProfileUrl(links.instagram.url, "instagram")
      ? links.instagram.url.trim()
      : null,
    whatsapp: links.whatsapp.enabled ? buildWhatsAppHref(links.whatsapp.number) : null,
  };
}
